<template>
  <div class="promo-banner" :class="classes">
    <picture>
      <source media="(min-width: 1366px)" :srcset="$props.image.ImageUrl">
      <source media="(min-width: 480px)" :srcset="$props.imageMD.ImageUrl">
      <source media="(max-width: 479px)" :srcset="$props.imageSM.ImageUrl">
      <img :src="$props.image.ImageUrl" class="promo-banner-img" alt="promo banner">
    </picture>
    <div class="promo-banner-text">
      <p class="promo-banner-title">{{ $props.title }}</p>
      <p class="promo-banner-description">{{ $props.description }}</p>
    </div>
    <base-button v-if="$props.personalizedOffer" @click="goToOffer" variant="primary">
      {{ $t('personalizedOffer.offerForYou') }}
    </base-button>
    <a v-else :href="$props.linkUrl" class="btn-white" target="_blank">{{ $props.linkName }}</a>
  </div>
</template>

<script>
import { addDataLayerEvent } from '@/services/dataLayer'

export default {
  name: 'promo-banner',
  props: {
    image: {
      type: Object,
      default: () => {
        return {}
      }
    },
    imageSM: {
      type: Object,
      default: () => {
        return {}
      }
    },
    imageMD: {
      type: Object,
      default: () => {
        return {}
      }
    },
    title: {
      type: String
    },
    description: {
      type: String
    },
    linkName: {
      type: String
    },
    linkUrl: {
      type: String
    },
    personalizedOffer: {
      type: Boolean
    },
    overlay: {
      type: String,
      default: 'none',
      validator: (value) => {
        const allowedOverlay = ['none', 'gradient']
        return allowedOverlay.includes(value)
      }
    },
    promoType: String
  },
  computed: {
    classes () {
      return {
        [`overlay-${this.$props.overlay}`]: this.$props.overlay
      }
    }
  },
  methods: {
    goToOffer () {
      this.$emit('go-to-offer')
      addDataLayerEvent({
        'banner type': this.$props.promoType,
        event: 'banner_click'
      })
    }
  }
}
</script>

<style scoped lang="scss">
.promo-banner {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  position: relative;
  box-shadow: 0 .3rem 1.5rem 0 rgba(0, 0, 0, .08);
  border-radius: .5rem;
  padding: 1.6rem;
  color: $white;
  min-height: 32rem;
  z-index: 1;

  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
    justify-content: flex-start;
    height: 0;
  }

  @media (map_get($breakpoints, exsm)) {
    min-height: 35rem;
  }

  @media (map_get($breakpoints, lg)) {
    min-height: 38rem;
  }

  &.overlay-gradient:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(60deg, #b10d28 10%, #ed1a3b 58%, #f58220 90%);
    z-index: -1;
    opacity: .75;
    border-radius: .5rem;
  }
}

.promo-banner-img {
  position: absolute;
  top: 0;
  left: 0;
  border-radius: .5rem;
  width: 100%;
  height: 100%;
  z-index: -2;
}

.promo-banner-text {
  margin-bottom: auto;
  padding-bottom: 2rem;
}

.promo-banner-title {
  display: inline-block;
  margin-bottom: 1rem;
  max-width: calc(100% - 3rem);
  font-size: 2.4rem;
  white-space: pre-line;
}

.promo-banner-description {
  font-size: 1.4rem;
}

.btn-white {
  display: inline-block;
  text-align: center;
  font-weight: 500;
  font-size: 1.6rem;
  line-height: 1.8rem;
  border: 1px solid transparent;
  border-radius: .5rem;
  cursor: pointer;
  min-width: 18rem;
  padding: 1.4rem;
  background: $white;
  color: $primary;
  transition: background-color 150ms, border-color 150ms;
}
</style>
